import React, { createContext, useState, useEffect, useMemo } from "react";
import { fetchCurrentUserInfo } from "../_services/userService";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const fetchAndSetUser = async () => {
        try {
          const user = await fetchCurrentUserInfo(); // wait for API
          setUserInfo(user);                         // then set state
          setIsLoggedIn(true);                       // mark as logged in
        } catch (err) {
          console.error("Failed to fetch user info:", err);
          setIsLoggedIn(false);
          setUserInfo(null);
        } finally {
          setLoading(false);
        }
      };

      fetchAndSetUser();
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token) => {
    localStorage.setItem("token", token);
    setIsLoggedIn(true);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
  };

  const fetchUserInfo = async (token) => {
    try {
      const userInfo = await fetchCurrentUserInfo();
      setUserInfo(userInfo);
    } catch (err) {
      console.error("Failed to fetch user info:", err);
    }
  };

  // Generic function to update user info fields
  const updateUserInformation = (updatedData) => {
    setUserInfo((prev) => ({
      ...prev,
      ...updatedData,
    }));
  };

  const updateAvatar = (newAvatar) => {
    setUserInfo((prevState) => ({
      ...prevState,
      image_url: newAvatar, // Update the avatar URL in the user info
    }));
  };

  // Memoize the context value to avoid unnecessary re-renders
  const contextValue = useMemo(
    () => ({
      isLoggedIn,
      userInfo,
      login,
      logout,
      loading,
      fetchUserInfo,
      updateAvatar,
      updateUserInformation, // now this can update any part of userInfo
    }),
    [isLoggedIn, userInfo]
  );

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export default AuthProvider;
